var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "nav", staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "待审核", name: "0" } }),
              _c("el-tab-pane", { attrs: { label: "驳回", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "已完成", name: "3" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowForm,
                expression: "isShowForm",
              },
            ],
            staticClass: "query",
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", { staticStyle: { color: "#333333" } }, [
                _vm._v("数据查询"),
              ]),
              _c(
                "p",
                {
                  staticStyle: {
                    "font-size": "14px",
                    color: "#409eff",
                    cursor: "pointer",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowForm = false
                    },
                  },
                },
                [_vm._v(" 收起 ")]
              ),
            ]),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  "label-width": "70px",
                  inline: true,
                  model: _vm.queryForm,
                  size: "mini",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "订单信息" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入调整编号/商品信息" },
                      model: {
                        value: _vm.queryForm.info,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "info", $$v)
                        },
                        expression: "queryForm.info",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "formItem", attrs: { label: "申请人" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "请输入申请人",
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryForm.applicant,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "applicant", $$v)
                          },
                          expression: "queryForm.applicant",
                        },
                      },
                      _vm._l(_vm.applicant, function (items) {
                        return _c("el-option", {
                          key: items.label,
                          attrs: { label: items.value, value: items.label },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "仓库" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "请选择仓库名称",
                          clearable: "",
                          "default-first-option": "",
                        },
                        model: {
                          value: _vm.queryForm.wareName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "wareName", $$v)
                          },
                          expression: "queryForm.wareName",
                        },
                      },
                      _vm._l(_vm.wareData, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { label: items.name, value: items.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.activeName == 0
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "流程节点" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "选择流程节点",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.process,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "process", $$v)
                              },
                              expression: "queryForm.process",
                            },
                          },
                          _vm._l(_vm.nodes, function (items) {
                            return _c("el-option", {
                              key: items.dictName,
                              attrs: {
                                label: items.dictName,
                                value: items.dictName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("el-form-item", { attrs: { label: "申请时间" } }, [
                  _c(
                    "div",
                    { staticClass: "selectDate" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          align: "right",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "picker-options": _vm.pickerOptions,
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.queryForm.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "date", $$v)
                          },
                          expression: "queryForm.date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: _vm.searchEvent,
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(" 搜索 ")]
                    ),
                    _c(
                      "el-button",
                      { attrs: { size: "mini" }, on: { click: _vm.reset } },
                      [_vm._v(" 重置 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.activeName != 3
        ? _c(
            "div",
            { staticClass: "btns" },
            [
              _vm.parArray.indexOf("tzApproveCode") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.approval("", "", 1, 1)
                        },
                      },
                    },
                    [_vm._v("批量批准")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("tzMoreBack") != -1 && _vm.activeName != 1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.approval("", "", 1, 1)
                        },
                      },
                    },
                    [_vm._v("批量驳回")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("tzMoreGuide") != -1 && _vm.activeName != 1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.batchGuideOrder },
                    },
                    [_vm._v("批量导单")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isShowForm,
                      expression: "!isShowForm",
                    },
                  ],
                  staticStyle: { position: "absolute", right: "10px" },
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.isShowForm = true
                    },
                  },
                },
                [_vm._v("搜索展开")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "tableContext" },
        [
          _c(
            "el-table",
            {
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.table.list },
              on: {
                "selection-change": _vm.handleSelectionChange,
                "row-click": _vm.rowEvent,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "序号", type: "index", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "调整编号", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "p",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.oddNumbers))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "progressBar",
                  label: "进度",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "p",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.progressBar))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "申请人" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "p",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.proposerName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "物流审核" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.auditor["物流经理审批"]
                          ? _c(
                              "p",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetail(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.auditor["物流经理审批"]) +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "p",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("--")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "财务审核" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.auditor["财务经理审批"]
                          ? _c(
                              "p",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetail(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.auditor["财务经理审批"]) +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "p",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("--")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.activeName != "1"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "date",
                      label: "申请时间",
                      "min-width": "110",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "p",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDetail(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$moment(scope.row.createTime)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      184914288
                    ),
                  })
                : _vm._e(),
              _vm.activeName == "1"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "date",
                      label: "驳回时间",
                      "min-width": "110",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "p",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDetail(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$moment(scope.row.createTime)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      184914288
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "operation" }, [
                          _vm.activeName == "1" &&
                          scope.row.isSelf == "1" &&
                          _vm.parArray.indexOf("tzAgainCode") != -1
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.wareFix(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("修改")]
                              )
                            : _vm._e(),
                          _vm.activeName == "0" &&
                          scope.row.isApprove == "1" &&
                          _vm.parArray.indexOf("TzaloneApproveCode") != -1 &&
                          scope.row.auditor["物流经理审批"] == "--" &&
                          _vm.roleName == "物流"
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.approval(
                                        scope.row.oddNumbers,
                                        scope.row.procInstId,
                                        1,
                                        2
                                      )
                                    },
                                  },
                                },
                                [_vm._v("批准")]
                              )
                            : _vm._e(),
                          _vm.activeName == "0" &&
                          _vm.roleName == "物流" &&
                          scope.row.isApprove == "1" &&
                          _vm.parArray.indexOf("tzAloneBackCode") != -1 &&
                          scope.row.auditor["物流经理审批"] == "--"
                            ? _c(
                                "span",
                                {
                                  staticStyle: { color: "#ff5656" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rejectEvent(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("驳回")]
                              )
                            : _vm._e(),
                          _vm.activeName == "0" &&
                          scope.row.isApprove == "1" &&
                          _vm.parArray.indexOf("TzaloneApproveCode") != -1 &&
                          scope.row.auditor["财务经理审批"] == "--" &&
                          _vm.roleName == "财务"
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.approval(
                                        scope.row.oddNumbers,
                                        scope.row.procInstId,
                                        1,
                                        2
                                      )
                                    },
                                  },
                                },
                                [_vm._v("批准")]
                              )
                            : _vm._e(),
                          _vm.activeName == "0" &&
                          _vm.roleName == "财务" &&
                          scope.row.isApprove == "1" &&
                          _vm.parArray.indexOf("tzAloneBackCode") != -1 &&
                          scope.row.auditor["财务经理审批"] == "--"
                            ? _c(
                                "span",
                                {
                                  staticStyle: { color: "#ff5656" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rejectEvent(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("驳回")]
                              )
                            : _vm._e(),
                          _vm.parArray.indexOf("tzlc") != -1
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.polliingEvent(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("流程")]
                              )
                            : _vm._e(),
                          (_vm.activeName == "1" || _vm.activeName == "0") &&
                          scope.row.isSelf == "1" &&
                          _vm.parArray.indexOf("tzDelectCode") != -1
                            ? _c(
                                "span",
                                {
                                  staticClass: "delect",
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectEvent(
                                        scope.row,
                                        scope.$index
                                      )
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticStyle: { height: "20px" } }),
      _vm.table.totalNum > 0
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pageNo,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.table.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "",
            visible: _vm.drawer,
            "with-header": false,
            "append-to-body": true,
            size: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawerBox" },
            [
              _c("p", { staticClass: "header" }, [_vm._v("库存调整单详情")]),
              _c("div", { staticClass: "nav" }, [
                _c("p", [_vm._v("调整编号：" + _vm._s(_vm.detail.oddNumbers))]),
                _c("p", [
                  _c("span", [
                    _vm._v(
                      "申请时间：" + _vm._s(_vm.$moment(_vm.detail.createdTime))
                    ),
                  ]),
                  _c("span", [
                    _vm._v("申请人：" + _vm._s(_vm.detail.proposerName)),
                  ]),
                ]),
              ]),
              _c(
                "el-table",
                { attrs: { data: _vm.detail.goods, stripe: true } },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", type: "index", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodsName",
                      label: "商品信息",
                      width: "220",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "frontPracticalStock",
                      label: "原来库存",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "laterPracticalStock",
                      label: "修改库存",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "修改数量", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "left-start",
                                  title: "",
                                  width: "200",
                                  trigger: "hover",
                                  content:
                                    "这是一段内容,这是一段内容,这是一段内容,这是一段内容。",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(scope.row.wars, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          display: "flex",
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            " " + _vm._s(item.warName) + " "
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.frontQuantity) +
                                              " "
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            " " + _vm._s(item.difference) + " "
                                          ),
                                        ]),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    scope.row.addFixNumber < 0
                                      ? _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.addFixNumber) +
                                              " "
                                          ),
                                        ])
                                      : _c("p", [
                                          _vm._v(
                                            "+" + _vm._s(scope.row.addFixNumber)
                                          ),
                                        ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "warAdName",
                      label: "调整原因",
                      "show-overflow": "",
                      "min-width": "120",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.reject,
            "append-to-body": true,
            title: "审批意见",
          },
          on: {
            "update:visible": function ($event) {
              _vm.reject = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "请输入驳回内容" },
                model: {
                  value: _vm.textarea,
                  callback: function ($$v) {
                    _vm.textarea = $$v
                  },
                  expression: "textarea",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.reject = false
                      _vm.approval(_vm.row.oddNumbers, _vm.row.procInstId, 2, 2)
                    },
                  },
                },
                [_vm._v("驳回 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.reject = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: "审核过程",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.polliing } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "步骤", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "任务节点",
                  prop: "taskName",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: { label: "办理人", prop: "assignee", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { label: "审批开始时间", prop: "startTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "审批结束时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.endTime
                          ? _c("span", [_vm._v(_vm._s(props.row.endTime))])
                          : _c("span", [_vm._v("正在处理中...")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审批意见", "show-overflow-tooltip": true },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.comment
                          ? _c("span", [_vm._v(_vm._s(props.row.comment))])
                          : _vm._e(),
                        props.row.comment
                          ? _c("span", [_vm._v("/")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }